function vsGalleryNeedsCarousel(container) {
  if (!container) return true;
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;
  const style = isDesktop
    ? (container.dataset.desktopStyle || 'carousel_side_thumbs')
    : (container.dataset.mobileStyle || 'carousel_dots');
  const staticStyles = isDesktop
    ? ['grid', 'split_columns', 'stacked_scroll']
    : ['grid_2col', 'stacked_scroll'];
  return staticStyles.indexOf(style) === -1;
}

if (!customElements.get('vs-product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      if (!this.product_container) return;
      this.galleryContainer = this.closest('.product-gallery-container');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      /* Desktop usa el controlador estable de la referencia que está al final
         de esta sección. Evita que Flickity calcule 0x0 dentro del Theme Editor. */
      if (window.matchMedia('(min-width: 900px)').matches) {
        this.useCarousel = false;
        this.setupProductGallery();
        return;
      }

      this.useCarousel = vsGalleryNeedsCarousel(this.galleryContainer);
      if (!this.useCarousel || typeof Flickity === 'undefined') {
        this.setupProductGallery();
        return;
      }
      this.setOptions();
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container ? this.thumbnail_container.querySelectorAll('.product-thumbnail') : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        /* Galería estable: sin loop infinito ni efecto resorte en extremos. */
        wrapAround: false,
        freeScroll: false,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        draggable: true,
        dragThreshold: 10,
        selectedAttraction: 0.09,
        friction: 0.60,
        cellSelector: '.product-images__slide.is-active',
      };
    }

    init() {
      if (this.flkty) { try { this.flkty.destroy(); } catch (e) {} }
      this.flkty = new Flickity(this, this.options);
      this.selectedIndex = this.flkty.selectedIndex;
      this.setupEvents();
      this.setupProductGallery();
    }

    reInit(imageSetIndex) {
      this.flkty.destroy();
      this.setOptions();
      this.flkty = new Flickity(this, this.options);
      this.setupEvents();
      this.selectedIndex = this.flkty.selectedIndex;
    }

    setupEvents() {
      const _this = this;

      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', () => { this.flkty.previous(); });
        prev.addEventListener('keyup', (event) => { if (event.key === 'Enter' || event.key === ' ') { this.flkty.previous(); event.preventDefault(); } });
        this.prev_button = prev;
      }

      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', () => { this.flkty.next(); });
        next.addEventListener('keyup', (event) => { if (event.key === 'Enter' || event.key === ' ') { this.flkty.next(); event.preventDefault(); } });
        this.next_button = next;
      }

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });

      this.flkty.on('settle', function (index) { _this.selectedIndex = index; });

      this.flkty.on('change', (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element;
        let previous_media = previous_slide.querySelector('.product-single__media');
        let active_thumbs = Array.from(this.thumbnails).filter((element) => element.classList.contains('is-active'));
        let active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item) => { item.classList.remove('is-initial-selected'); });
        if (active_thumb) active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (!active_thumb || active_thumb.offsetParent === null) return;
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2;
          const windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth',
          });
        });

        if (previous_media && previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media && previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }
      });

      setTimeout(() => {
        Array.from(this.thumbnails).filter((element) => element.clientWidth > 0).forEach((thumbnail, index) => {
          /* reInit no puede duplicar listeners en las miniaturas. */
          if (thumbnail.dataset.vsFlickityThumbBound === 'true') return;
          thumbnail.dataset.vsFlickityThumbBound = 'true';

          thumbnail.addEventListener('click', () => {
            if (!this.flkty) return;
            this.thumbnailClick(thumbnail, index);
          });
        });
      });
    }

    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) { el.classList.remove('is-initial-selected'); });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }

    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }

    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }

    setupProductGallery() {
      if (this.querySelectorAll('.product-single__media-zoom').length) this.setEventListeners();
    }

    setEventListeners() {
      const slider = this;
      slider.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        if (link.dataset.zoomBound === 'true') return;
        link.dataset.zoomBound = 'true';
        link.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          openProductZoom(slider, link);
        });
      });
    }

    disconnectedCallback() {
      if (this.flkty) this.flkty.destroy();
    }
  }
  customElements.define('vs-product-slider', ProductSlider);
}

function vsLightboxSectionId(slider) {
  return String(slider && slider.id ? slider.id : '').replace('Product-Slider-', '');
}

function vsLightboxForceGeometry(overlay) {
  if (!overlay) return;
  const force = function (el, props) {
    if (!el) return;
    Object.keys(props).forEach(function (key) {
      el.style.setProperty(key, props[key], 'important');
    });
  };

  force(overlay, {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    width: '100vw',
    height: '100dvh',
    margin: '0px',
    padding: '0px',
    'max-width': 'none',
    'max-height': 'none',
    'border-radius': '0px',
    border: '0px',
    'box-shadow': 'none',
    transform: 'none',
    background: '#ffffff',
    'z-index': '2147483647'
  });

  force(overlay.querySelector('.vs-product-lightbox__backdrop'), {
    position: 'absolute',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    background: '#ffffff',
    opacity: '1',
    'z-index': '0'
  });

  force(overlay.querySelector('.vs-product-lightbox__stage'), {
    position: 'absolute',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    background: 'transparent',
    'z-index': '2'
  });
}

function vsLightboxGetOverlay(slider) {
  const id = vsLightboxSectionId(slider);
  const overlay = document.getElementById('vs-product-lightbox-' + id);
  if (!overlay) return null;

  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }

  vsLightboxForceGeometry(overlay);
  return overlay;
}

function vsLightboxContainedRect(img, fallbackW, fallbackH) {
  if (!img) return null;

  const box = img.getBoundingClientRect();
  const nw = img.naturalWidth || fallbackW || box.width || 1;
  const nh = img.naturalHeight || fallbackH || box.height || 1;

  if (!box.width || !box.height || !nw || !nh) return box;

  const scale = Math.min(box.width / nw, box.height / nh);
  const width = nw * scale;
  const height = nh * scale;

  return {
    left: box.left + (box.width - width) / 2,
    top: box.top + (box.height - height) / 2,
    width: width,
    height: height,
    right: box.left + (box.width - width) / 2 + width,
    bottom: box.top + (box.height - height) / 2 + height
  };
}

function vsLightboxTargetRect(item) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const horizontalGap = vw <= 767 ? 28 : 72;
  const verticalGap = vw <= 767 ? 72 : 56;
  const maxW = Math.max(120, vw - horizontalGap * 2);
  const maxH = Math.max(120, vh - verticalGap * 2);
  const ratio = Math.max(.01, (item.w || 1) / (item.h || 1));

  let width = maxW;
  let height = width / ratio;

  if (height > maxH) {
    height = maxH;
    width = height * ratio;
  }

  return {
    left: (vw - width) / 2,
    top: (vh - height) / 2,
    width: width,
    height: height
  };
}

function vsLightboxApplyRect(img, rect, animate, duration) {
  if (!img || !rect) return;

  const ms = typeof duration === 'number' ? duration : 420;
  const easing = 'cubic-bezier(.16,1,.3,1)';
  img.style.setProperty('transition', animate
    ? 'left ' + ms + 'ms ' + easing + ', top ' + ms + 'ms ' + easing + ', width ' + ms + 'ms ' + easing + ', height ' + ms + 'ms ' + easing + ', transform ' + ms + 'ms ' + easing + ', opacity ' + Math.min(ms, 260) + 'ms ease'
    : 'none', 'important');

  img.style.setProperty('left', rect.left + 'px', 'important');
  img.style.setProperty('top', rect.top + 'px', 'important');
  img.style.setProperty('width', rect.width + 'px', 'important');
  img.style.setProperty('height', rect.height + 'px', 'important');
}

function vsLightboxCollectItems(slider) {
  return Array.from(slider.querySelectorAll('.product-images__slide.is-active'))
    .map(function (slide) {
      const link = slide.querySelector('.product-single__media-zoom');
      const preview = slide.querySelector('.product-single__media-image img');

      if (!link || !preview) return null;

      const width = parseInt(link.dataset.w, 10) || preview.naturalWidth || 1600;
      const height = parseInt(link.dataset.h, 10) || preview.naturalHeight || 1600;

      return {
        slide: slide,
        link: link,
        preview: preview,
        previewSrc: preview.currentSrc || preview.src || link.getAttribute('href'),
        src: link.getAttribute('href'),
        w: width,
        h: height,
        alt: preview.getAttribute('alt') || ''
      };
    })
    .filter(Boolean);
}

function vsLightboxClamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function vsLightboxGetZoomRect(overlay, originX, originY) {
  const state = overlay && overlay.__vsState;
  if (!state) return null;

  const item = state.items[state.index];
  const base = vsLightboxTargetRect(item);
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const factor = vw <= 767 ? 2.15 : 2.0;
  const ax = vsLightboxClamp(typeof originX === 'number' ? originX : 50, 0, 100) / 100;
  const ay = vsLightboxClamp(typeof originY === 'number' ? originY : 50, 0, 100) / 100;
  const width = base.width * factor;
  const height = base.height * factor;

  let left = base.left - (width - base.width) * ax;
  let top = base.top - (height - base.height) * ay;

  if (width <= vw) left = (vw - width) / 2;
  else left = vsLightboxClamp(left, vw - width, 0);

  if (height <= vh) top = (vh - height) / 2;
  else top = vsLightboxClamp(top, vh - height, 0);

  return { left: left, top: top, width: width, height: height };
}

function vsLightboxSetZoom(overlay, enabled, originX, originY, instant) {
  if (!overlay || !overlay.__vsState) return;

  const img = overlay.querySelector('[data-vs-lightbox-image]');
  const zoomButton = overlay.querySelector('[data-vs-lightbox-zoom]');
  if (!img) return;

  const state = overlay.__vsState;
  const item = state.items[state.index];
  const baseRect = vsLightboxTargetRect(item);

  overlay.__vsZoomed = !!enabled;
  overlay.__vsPanActive = false;
  overlay.__vsPanPointer = null;
  overlay.__vsPanMoved = false;

  img.classList.toggle('is-zoomed', !!enabled);
  if (zoomButton) {
    zoomButton.classList.toggle('is-active', !!enabled);
    zoomButton.setAttribute('aria-label', enabled ? 'Reducir imagen' : 'Ampliar imagen');
    zoomButton.setAttribute('title', enabled ? 'Reducir imagen' : 'Ampliar imagen');
  }

  if (enabled) {
    const zoomRect = vsLightboxGetZoomRect(overlay, originX, originY);
    state.zoomRect = zoomRect;
    vsLightboxApplyRect(img, zoomRect, !instant, 380);
    img.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
    img.style.cursor = 'zoom-out';
  } else {
    state.zoomRect = null;
    vsLightboxApplyRect(img, baseRect, !instant, 340);
    img.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
    img.style.cursor = 'zoom-in';
  }
}

function vsLightboxUpdateButtons(overlay) {
  const state = overlay.__vsState;
  if (!state) return;

  const prev = overlay.querySelector('[data-vs-lightbox-prev]');
  const next = overlay.querySelector('[data-vs-lightbox-next]');
  const counter = overlay.querySelector('[data-vs-lightbox-counter]');

  if (prev) prev.disabled = state.index <= 0;
  if (next) next.disabled = state.index >= state.items.length - 1;
  if (counter) counter.textContent = (state.index + 1) + ' / ' + state.items.length;
}

function vsLightboxAnimateControl(button) {
  if (!button || button.disabled) return;

  button.classList.remove('is-animating');
  void button.offsetWidth;
  button.classList.add('is-animating');

  window.setTimeout(function () {
    button.classList.remove('is-animating');
  }, 320);
}

function vsLightboxSyncSlider(state) {
  if (!state || !state.slider) return;

  try {
    if (state.slider.flkty && typeof state.slider.flkty.select === 'function') {
      state.slider.flkty.select(state.index, false, true);
      state.slider.selectedIndex = state.index;
    }
  } catch (e) {}
}

function vsLightboxPreload(src, done) {
  if (!src) {
    done(false);
    return;
  }

  const preload = new Image();
  let finished = false;

  const finish = function (ok) {
    if (finished) return;
    finished = true;
    done(ok);
  };

  preload.onload = function () { finish(true); };
  preload.onerror = function () { finish(false); };
  preload.src = src;

  if (preload.complete && preload.naturalWidth) finish(true);
}

function vsLightboxUpgradeImage(overlay, item, indexAtRequest) {
  if (!overlay || !item || !item.src || item.src === item.previewSrc) return;

  vsLightboxPreload(item.src, function (ok) {
    if (!ok || !overlay.__vsState || overlay.__vsState.index !== indexAtRequest) return;

    const img = overlay.querySelector('[data-vs-lightbox-image]');
    if (!img) return;

    img.src = item.src;
  });
}

function vsLightboxLoadIndex(overlay, nextIndex, direction) {
  const state = overlay.__vsState;

  if (
    !state ||
    state.changing ||
    nextIndex < 0 ||
    nextIndex >= state.items.length ||
    nextIndex === state.index
  ) return;

  state.changing = true;
  const main = overlay.querySelector('[data-vs-lightbox-image]');
  const nextItem = state.items[nextIndex];
  const dir = direction > 0 ? 1 : -1;

  const startSwap = function () {
    vsLightboxPreload(nextItem.previewSrc || nextItem.src, function () {
      if (!overlay.__vsState || !overlay.classList.contains('is-open')) {
        state.changing = false;
        return;
      }

      const incoming = document.createElement('img');
      incoming.className = 'vs-product-lightbox__image vs-product-lightbox__image--incoming';
      incoming.alt = nextItem.alt || '';
      incoming.draggable = false;
      incoming.src = nextItem.previewSrc || nextItem.src;
      overlay.querySelector('[data-vs-lightbox-stage]').appendChild(incoming);

      const target = vsLightboxTargetRect(nextItem);
      vsLightboxApplyRect(incoming, target, false);
      incoming.style.setProperty('opacity', '0', 'important');
      incoming.style.setProperty('transform', 'translate3d(' + (dir * 34) + 'px,0,0) scale(.985)', 'important');

      main.style.setProperty('transition', 'transform 340ms cubic-bezier(.16,1,.3,1), opacity 220ms ease', 'important');
      main.style.setProperty('transform', 'translate3d(' + (-dir * 26) + 'px,0,0) scale(.992)', 'important');
      main.style.setProperty('opacity', '.18', 'important');

      void incoming.offsetWidth;
      incoming.style.setProperty('transition', 'transform 420ms cubic-bezier(.16,1,.3,1), opacity 260ms ease', 'important');
      incoming.style.setProperty('opacity', '1', 'important');
      incoming.style.setProperty('transform', 'translate3d(0,0,0) scale(1)', 'important');

      state.index = nextIndex;

      /*
        El visor navega de forma independiente.
        La galería principal se sincroniza una sola vez al cerrar.
      */
      vsLightboxUpdateButtons(overlay);

      window.setTimeout(function () {
        main.alt = nextItem.alt || '';
        main.src = nextItem.previewSrc || nextItem.src;
        vsLightboxApplyRect(main, target, false);
        main.style.setProperty('opacity', '1', 'important');
        main.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
        incoming.remove();
        vsLightboxUpgradeImage(overlay, nextItem, nextIndex);
        if (overlay.__vsState) overlay.__vsState.changing = false;
      }, 430);
    });
  };

  if (overlay.__vsZoomed) {
    vsLightboxSetZoom(overlay, false, 50, 50, false);
    window.setTimeout(startSwap, 350);
  } else {
    startSwap();
  }
}

function vsLightboxClose(overlay) {
  if (
    !overlay ||
    !overlay.classList.contains('is-open') ||
    overlay.__vsClosing
  ) return;

  overlay.__vsClosing = true;

  const state = overlay.__vsState;
  const img = overlay.querySelector('[data-vs-lightbox-image]');
  const item = state && state.items[state.index];

  vsLightboxSetZoom(overlay, false);

  if (state) {
    vsLightboxSyncSlider(state);
  }

  overlay.classList.remove('is-ready');

  overlay.querySelectorAll('.vs-product-lightbox__image--incoming').forEach(function (el) { el.remove(); });

  const finishClose = function () {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');

    img.style.transition = 'none';
    img.style.transform = 'translate3d(0,0,0)';
    img.style.left = '';
    img.style.top = '';
    img.style.width = '';
    img.style.height = '';
    img.style.opacity = '1';
    img.style.transform = 'translate3d(0,0,0)';
    img.alt = '';
    /* Mantener src evita que Safari pinte el ALT como texto de imagen rota. */

    overlay.querySelectorAll('.vs-product-lightbox__image--incoming').forEach(function (el) { el.remove(); });
    overlay.__vsState = null;
    overlay.__vsClosing = false;

    document.documentElement.classList.remove('vs-product-lightbox-open');
    document.body.classList.remove('vs-product-lightbox-open');
  };

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      const sourceRect =
        item && item.preview
          ? vsLightboxContainedRect(item.preview, item.w, item.h)
          : null;

      if (sourceRect && sourceRect.width > 1 && sourceRect.height > 1) {
        vsLightboxApplyRect(img, sourceRect, true);
        window.setTimeout(finishClose, 410);
      } else {
        img.style.transition = 'transform .30s cubic-bezier(.22,1,.36,1)';
        img.style.transform = 'scale(.96)';
        window.setTimeout(finishClose, 310);
      }
    });
  });
}

function vsLightboxBind(overlay) {
  if (overlay.__vsBound) return;
  overlay.__vsBound = true;

  const img = overlay.querySelector('[data-vs-lightbox-image]');
  const zoom = overlay.querySelector('[data-vs-lightbox-zoom]');
  const close = overlay.querySelector('[data-vs-lightbox-close-button]');
  const prev = overlay.querySelector('[data-vs-lightbox-prev]');
  const next = overlay.querySelector('[data-vs-lightbox-next]');
  const stage = overlay.querySelector('[data-vs-lightbox-stage]');

  if (close) {
    close.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      vsLightboxAnimateControl(close);
      window.setTimeout(function () {
        vsLightboxClose(overlay);
      }, 70);
    });
  }

  if (prev) {
    prev.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      vsLightboxAnimateControl(prev);
      if (overlay.__vsState) {
        vsLightboxLoadIndex(overlay, overlay.__vsState.index - 1, -1);
      }
    });
  }

  if (next) {
    next.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      vsLightboxAnimateControl(next);
      if (overlay.__vsState) {
        vsLightboxLoadIndex(overlay, overlay.__vsState.index + 1, 1);
      }
    });
  }

  if (zoom) {
    zoom.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      vsLightboxAnimateControl(zoom);
      vsLightboxSetZoom(overlay, !overlay.__vsZoomed);
    });
  }

  if (img) {
    img.addEventListener('click', function (event) {
      event.stopPropagation();

      /*
        Después de un PAN, Safari/Chrome puede generar un click fantasma.
        Lo ignoramos para que no cierre el zoom accidentalmente.
      */
      if (overlay.__vsSuppressImageClick) {
        overlay.__vsSuppressImageClick = false;
        return;
      }

      const rect = img.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      vsLightboxSetZoom(overlay, !overlay.__vsZoomed, x, y);
    });
  }

  if (stage) {
    stage.addEventListener('click', function (event) {
      if (event.target === stage) {
        vsLightboxClose(overlay);
      }
    });

    let swipeStartX = null;
    let swipeStartY = null;

    let panStartX = 0;
    let panStartY = 0;
    let panStartLeft = 0;
    let panStartTop = 0;

    stage.addEventListener('pointerdown', function (event) {
      if (!overlay.__vsState || !img) return;

      if (overlay.__vsZoomed) {
        /*
          ZOOM ACTIVO:
          el usuario arrastra físicamente la imagen ampliada.
          Funciona con mouse, touch y pen.
        */
        overlay.__vsPanActive = true;
        overlay.__vsPanPointer = event.pointerId;
        overlay.__vsPanMoved = false;

        panStartX = event.clientX;
        panStartY = event.clientY;

        const rect = img.getBoundingClientRect();
        panStartLeft = rect.left;
        panStartTop = rect.top;

        img.style.setProperty('transition', 'none', 'important');

        try {
          if (stage.setPointerCapture && event.pointerId != null) {
            stage.setPointerCapture(event.pointerId);
          }
        } catch (e) {}

        event.preventDefault();
        return;
      }

      /*
        ZOOM INACTIVO:
        el swipe horizontal cambia de imagen.
      */
      swipeStartX = event.clientX;
      swipeStartY = event.clientY;
    });

    stage.addEventListener('pointermove', function (event) {
      if (
        !overlay.__vsZoomed ||
        !overlay.__vsPanActive ||
        overlay.__vsPanPointer !== event.pointerId ||
        !img ||
        !overlay.__vsState
      ) return;

      event.preventDefault();

      const state = overlay.__vsState;
      const zoomRect = state.zoomRect || vsLightboxGetZoomRect(overlay, 50, 50);
      if (!zoomRect) return;

      const dx = event.clientX - panStartX;
      const dy = event.clientY - panStartY;

      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
        overlay.__vsPanMoved = true;
      }

      const vw = window.innerWidth;
      const vh = window.innerHeight;

      let left = zoomRect.width > vw
        ? vsLightboxClamp(panStartLeft + dx, vw - zoomRect.width, 0)
        : (vw - zoomRect.width) / 2;

      let top = zoomRect.height > vh
        ? vsLightboxClamp(panStartTop + dy, vh - zoomRect.height, 0)
        : (vh - zoomRect.height) / 2;

      img.style.setProperty('left', left + 'px', 'important');
      img.style.setProperty('top', top + 'px', 'important');
    }, { passive:false });

    function finishPan(event) {
      if (!overlay.__vsPanActive) return false;

      if (
        overlay.__vsPanPointer !== null &&
        event &&
        event.pointerId !== overlay.__vsPanPointer
      ) return false;

      const moved = !!overlay.__vsPanMoved;

      overlay.__vsPanActive = false;
      overlay.__vsPanPointer = null;
      overlay.__vsPanMoved = false;

      if (moved) {
        overlay.__vsSuppressImageClick = true;

        window.setTimeout(function () {
          overlay.__vsSuppressImageClick = false;
        }, 90);
      }

      return true;
    }

    stage.addEventListener('pointercancel', function (event) {
      if (overlay.__vsZoomed) finishPan(event);
      swipeStartX = null;
      swipeStartY = null;
    });

    stage.addEventListener('pointerup', function (event) {
      if (overlay.__vsZoomed) {
        finishPan(event);
        return;
      }

      if (
        swipeStartX === null ||
        swipeStartY === null ||
        !overlay.__vsState
      ) {
        swipeStartX = null;
        swipeStartY = null;
        return;
      }

      const dx = event.clientX - swipeStartX;
      const dy = event.clientY - swipeStartY;

      swipeStartX = null;
      swipeStartY = null;

      /*
        Solo un gesto claramente horizontal cambia de imagen.
        Esto evita disparos accidentales.
      */
      if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;

      if (dx < 0) {
        if (next) vsLightboxAnimateControl(next);
        vsLightboxLoadIndex(overlay, overlay.__vsState.index + 1, 1);
      } else {
        if (prev) vsLightboxAnimateControl(prev);
        vsLightboxLoadIndex(overlay, overlay.__vsState.index - 1, -1);
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!overlay.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      if (close) vsLightboxAnimateControl(close);
      window.setTimeout(function () {
        vsLightboxClose(overlay);
      }, 70);
    } else if (event.key === 'ArrowLeft') {
      if (prev) vsLightboxAnimateControl(prev);
      if (overlay.__vsState) {
        vsLightboxLoadIndex(overlay, overlay.__vsState.index - 1, -1);
      }
    } else if (event.key === 'ArrowRight') {
      if (next) vsLightboxAnimateControl(next);
      if (overlay.__vsState) {
        vsLightboxLoadIndex(overlay, overlay.__vsState.index + 1, 1);
      }
    }
  });

  window.addEventListener('resize', function () {
    if (
      !overlay.classList.contains('is-open') ||
      !overlay.__vsState ||
      overlay.__vsClosing
    ) return;

    const item = overlay.__vsState.items[overlay.__vsState.index];
    vsLightboxSetZoom(overlay, false, 50, 50, true);
    vsLightboxApplyRect(img, vsLightboxTargetRect(item), false);
  });
}

function openProductZoom(slider, clickedLink) {
  try {
    const overlay = vsLightboxGetOverlay(slider);
    if (!overlay) return;

    vsLightboxBind(overlay);

    const items = vsLightboxCollectItems(slider);
    if (!items.length) return;

    const currentSlide = clickedLink.closest('.product-images__slide');
    let index = items.findIndex(function (item) {
      return item.slide === currentSlide;
    });

    if (index < 0) {
      index = Math.max(0, Number(clickedLink.dataset.index || 0));
    }

    if (index >= items.length) index = 0;

    const item = items[index];
    const img = overlay.querySelector('[data-vs-lightbox-image]');
    if (!img) return;

    const sourceRect =
      vsLightboxContainedRect(item.preview, item.w, item.h) ||
      item.preview.getBoundingClientRect();

    const targetRect = vsLightboxTargetRect(item);

    overlay.__vsState = {
      slider: slider,
      items: items,
      index: index,
      changing: false
    };

    overlay.__vsClosing = false;
    vsLightboxSetZoom(overlay, false, 50, 50, true);

    img.alt = item.alt || '';
    img.src = item.previewSrc || item.src;
    img.style.transform = 'translate3d(0,0,0)';
    vsLightboxApplyRect(img, sourceRect, false);

    document.documentElement.classList.add('vs-product-lightbox-open');
    document.body.classList.add('vs-product-lightbox-open');

    overlay.classList.remove('is-ready');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');

    vsLightboxForceGeometry(overlay);
    vsLightboxUpdateButtons(overlay);

    void overlay.offsetWidth;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!overlay.classList.contains('is-open')) return;

        overlay.classList.add('is-ready');
        vsLightboxApplyRect(img, targetRect, true);
        vsLightboxUpgradeImage(overlay, item, index);
      });
    });
  } catch (error) {
    console.error('[VS product lightbox]', error);
  }
}